"use strict";exports.__esModule=!0,exports.uuid=void 0;var uuid_1=require("uuid");exports.uuid=uuid_1.v4;